var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.0226C24 10.0421 19.968 6 15 6C10.032 6 6 10.0421 6 15.0226C6 19.3895 9.096 23.0256 13.2 23.8647V17.7293H11.4V15.0226H13.2V12.7669C13.2 11.0256 14.613 9.60902 16.35 9.60902H18.6V12.3158H16.8C16.305 12.3158 15.9 12.7218 15.9 13.218V15.0226H18.6V17.7293H15.9V24C20.445 23.5489 24 19.7053 24 15.0226Z",
    fill: "#F04336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.309b6286f7af61a54b153d4c36dac2d1.svg";
export { ForwardRef as ReactComponent };